
@if( bLoaded ) {

	<div class="theForm">
	
		@for( question of questionTree; track question.id ) {
	
			@if( question.bIsVisible ) {
	
				<question
					[formGroup]="formGroup"
					[question]="question"
				/>
	
			}
	
		}
	
	</div>
	
}

<div style="text-align: center; margin-top: 20px;">

	<button
		mat-raised-button
		[routerLink]="[ '/Veranstaltungen', 'visualisieren' ]"
		[queryParams]="{ id: _event.id }"
	>
		zurück zur Veranstaltung
	</button>

</div>
